// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';

export class RevokeTokenOutput {
  readonly success?: boolean;

  constructor(data: { [key: string]: any } = {}) {
    this.success = data.success;
  }

  static zero(): RevokeTokenOutput {
    const zeroValues: ExcludeMethodsDeep<RevokeTokenOutput> = {};
    return new RevokeTokenOutput(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type RevokeTokenOutputWireFormat = {
  success?: boolean;
};

type NewRevokeTokenOutputProps = PartialDeep<RevokeTokenOutput, { recurseIntoArrays: true }>;
export const NewRevokeTokenOutput: (props: NewRevokeTokenOutputProps) => RevokeTokenOutput = (
  props,
) => new RevokeTokenOutput(props);

type NewRevokeTokenOutputFromWireFormatProps = PartialDeep<
  RevokeTokenOutputWireFormat,
  { recurseIntoArrays: true }
>;
export const NewRevokeTokenOutputFromWireFormat: (
  props: NewRevokeTokenOutputFromWireFormatProps,
) => RevokeTokenOutput = (props) => new RevokeTokenOutput(props);
